import { Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';

@Injectable({
	providedIn: 'root'
})
export class SnackbarService {

	constructor(private _snackBar: MatSnackBar) {
	}

	openSnackBar(message: string, action?: string, duration?: number, type?: string): void {
		const config = new MatSnackBarConfig();
		config.verticalPosition = 'top';
		config.horizontalPosition = 'end';
		config.politeness = 'assertive';
		config.duration = duration;
		config.panelClass = type ? type : 'alert';
		this._snackBar.open(message, action, config);
	}
}
